module.exports = __webpack_public_path__ + "img/222.74dc25f4.jpg";